<template>
  <v-container fluid>
    <PageHeading
      :text="'Блог посты'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-blog-post-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать пост блога
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridBlogPosts ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridBlogPosts from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageBlogPosts',
  components: {
    PageHeading,
    GridBlogPosts
  },
  metaInfo () {
    return {
      title: 'Посты блога'
    }
  },
  mixins: [gridPageInterface]
}
</script>
